import React from 'react'

import Image from 'next/image'

import { PaddingProps } from 'styled-system'

import { SectionWrapper } from 'Components/Blocks'
import { WHAT_WE_STAND_FOR_ITEMS } from 'Components/Sections/WhatWeStandFor/constants'
import { Column, Row, Text } from 'Components/UI'

import { Content, List } from './styles'

type Props = PaddingProps

function WhoWeAreSection({ ...rest }: Props) {
  return (
    <SectionWrapper {...rest}>
      <Content flexDirection={['column', 'column', 'column', 'column', 'row']}>
        <Column>
          <Text as="h2" mb={4} medium title title40>
            What We Stand For
          </Text>

          <Text
            body
            body16
            maxWidth={['unset', 'unset', 'unset', 'unset', '360px']}
            semiLight
          >
            Here’s what guides every decision, commit, and conversation:
          </Text>
        </Column>

        <List
          gridTemplateColumns={['1fr', '1fr', '1fr', '1fr', 'repeat(2, 1fr)']}
          maxWidth={['unset', 'unset', 'unset', 'unset', '60%']}
        >
          {WHAT_WE_STAND_FOR_ITEMS.map(item => (
            <Column key={item.id}>
              <Row alignCenter gap={5} mb={5}>
                {/* decorative — the title next to it carries the meaning */}
                <Image alt="" height={20} src={item.icon} width={20} />

                <Text body body20 medium>
                  {item.title}
                </Text>
              </Row>

              <Text body body16 semiLight>
                {item.caption}
              </Text>
            </Column>
          ))}
        </List>
      </Content>
    </SectionWrapper>
  )
}

export default WhoWeAreSection
